import { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import { useAuth } from "../contexts/SupabaseAuthProvider";
import { useNavigate } from "react-router-dom";
import "./affiliate-dashboard.css";

export default function AffiliateDashboard() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [aff, setAff] = useState(null);

  useEffect(() => {
    if (!user) {
      navigate("/affiliate/login");
      return;
    }

    supabase
      .from("affiliates")
      .select("*")
      .eq("id", user.id)
      .single()
      .then(({ data }) => {
        if (!data) navigate("/affiliate/signup");
        else setAff(data);
      });
  }, [user, navigate]);

  if (!aff) return <div className="aff-loading">Loading...</div>;

  const base = window.location.origin;
  const revenueLink = `${base}/signup?ref=${aff.affiliate_code}&type=revenue`;
  const turnoverLink = `${base}/signup?ref=${aff.affiliate_code}&type=turnover`;

  return (
    <div className="aff-root">
      <aside className="aff-sidebar">
        <h2 className="aff-logo">AFFILIATE</h2>
        <nav>
          <a className="active">Dashboard</a>
          <a>Links</a>
          <a>Statistics</a>
          <a>Support</a>
        </nav>
      </aside>

      <main className="aff-main">
        <h1>Dashboard</h1>

        <div className="aff-cards">
          <div className="aff-card">
            <span>Balance</span>
            <strong>${Number(aff.balance || 0).toFixed(2)}</strong>
          </div>

          <div className="aff-card">
            <span>Total Earned</span>
            <strong>${Number(aff.total_earned || 0).toFixed(2)}</strong>
          </div>

          <div className="aff-card">
            <span>Total Users</span>
            <strong>{aff.total_users || 0}</strong>
          </div>
        </div>

        <div className="aff-section">
          <h3>Your Links</h3>

          <div className="aff-link-box">
            <label>Revenue Share</label>
            <input readOnly value={revenueLink} />
          </div>

          <div className="aff-link-box">
            <label>Turnover</label>
            <input readOnly value={turnoverLink} />
          </div>
        </div>
      </main>
    </div>
  );
}
